<div class="container-fluid p-0 h-100">
    <div class="iframe-container h-100">
      <iframe class="w-100 h-100" title="LW_Dashboard" 
          [attr.src]="powerBIUrl"
          frameborder="0" allowfullscreen>
      </iframe>
    </div>
  </div>
  